export default "__VITE_ASSET__CYuaLF_L__"